import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Grid,
  Card,
  CardContent,
  Button,
  Paper,
  useTheme
} from '@mui/material';
import { motion } from 'framer-motion';
import { FaGooglePlay, FaApple, FaGlobe } from 'react-icons/fa';

const androidApps = [
  { title: 'Kirupam',        url: 'https://play.google.com/store/apps/details?id=com.lemda.kirupam1',    desc: 'Multi-region food order app.' },
  { title: 'Kirupam Bridge', url: 'https://play.google.com/store/apps/details?id=com.lemmda.bridge1',  desc: 'Delivery connector.' },
  { title: 'NeuroQuilt',     url: 'https://play.google.com/store/apps/details?id=com.lemda.NeuroQuilt', desc: 'AI Sudoku challenge.' },
  { title: 'BayEx Driver',   url: 'https://play.google.com/store/apps/details?id=com.lemmda.klimodriverki', desc: 'BayEx partner app.' },
  { title: 'BayEx Rider',    url: 'https://play.google.com/store/apps/details?id=com.lemda.bayex_riderkir', desc: 'BayEx customer app.' },
  { title: 'BayEx',          url: 'https://play.google.com/store/apps/details?id=com.lemda.Bayexnewki',      desc: 'E-commerce & delivery.' },
  { title: 'Perfect Edu',    url: 'https://play.google.com/store/apps/details?id=com.lemda.perfect_edu_new', desc: 'AI e-learning platform.' },
  { title: 'K LIMO',         url: 'https://play.google.com/store/apps/details?id=com.lemmda.klimo',      desc: 'Chauffeur booking.' },
  { title: 'Al Ikhlas homeschool',         url: 'https://play.google.com/store/apps/details?id=com.lemmda.homeschool',      desc: 'Online school' },
];

const iosApps = [
  { title: 'K LIMO DRIVER',  url: 'https://apps.apple.com/lk/app/k-limo-driver/id6575362003',   desc: 'Deliver or ride on your schedule.' },
  { title: 'K LIMO',         url: 'https://apps.apple.com/lk/app/k-limo/id6544791116',         desc: 'Luxury chauffeur on iOS.' },
  { title: 'Kirupam Food & Drink', url: 'https://apps.apple.com/lk/app/kirupam/id6464373784', desc: 'Order food & beverages.' },
  { title: 'Kirupam Bridge', url: 'https://apps.apple.com/lk/app/kirupam-bridge/id1588855254',   desc: 'Multi-region delivery connector.' },
];

const websites = [
  {
    title: 'Kirupam',
    url: 'https://kirupam.com/',
    logo: 'https://kirupam.com/logo.png'
  },
   {
    title: 'VTMMV ALUMNI ASSOCIATION UK',
    url: 'https://mahavidyansuk.org/',
    logo: 'https://mahavidyansuk.org/logo.jpg'
  },
  {
    title: 'Lifeline Community Relief',
    url: 'https://www.lifelinecommunityrelief.org/',
    logo: 'https://www.lifelinecommunityrelief.org/logo.png'
  },
  {
    title: 'PKMK Construction',
    url: 'https://pkmkconstruction.co.uk/',
    logo: 'https://pkmkconstruction.co.uk/pkmklogo.png'
  },
  {
    title: 'Sai Builders',
    url: 'https://saibuilders.co.uk/',
    logo: 'https://saibuilders.co.uk/saiblogo.png'
  },
  {
    title: 'RichShelf',
    url: 'https://richshelf.co.uk/',
    logo: 'https://richshelf.co.uk/wp-content/uploads/2024/12/cropped-Rich-shelf-7-600x200.png'
  },
  {
    title: 'World Chiller',
    url: 'https://worldchiller.co.uk/',
    logo: 'https://worldchiller.co.uk/wp-content/uploads/2024/12/WhatsApp-Image-2024-12-31-at-19.29.47-e1735653887841-300x161.jpeg'
  },
  {
    title: 'Yoan Wholesale',
    url: 'https://yoanwholesale.co.uk/',
    logo: 'https://yoanwholesale.co.uk/wp-content/uploads/2025/01/cropped-WhatsApp-Image-2025-01-18-at-16.30.21-1-600x162.jpeg'
  },
  {
    title: 'Dubai Shopping',
    url: 'https://dubaishopping.lk/',
    logo: 'https://dubaishopping.lk/wp-content/uploads/2024/12/DUBAI-tr1-e1678953756420-600x187.png'
  },
  {
    title: 'AlRahman Int’l',
    url: 'https://alrahmaninternational.co.uk/',
    logo: 'https://alrahmaninternational.co.uk/admin/uploads/AL%20Rahman%20international%20(2).png'
  },
  {
    title: 'KRS Cake City',
    url: 'https://krscakecity.com/',
    logo: 'https://krscakecity.com/static/media/logo.0ef3424daee6029d601b.png'
  },
  {
    title: 'Ranjan & Co',
    url: 'https://ranjanandco.com/',
    logo: 'https://ranjanandco.com/logos/WhatsApp%20Image%202025-06-09%20at%204.39.54%20PM.jpeg'
  },
  {
    title: 'DEST',
    url: 'https://dest.lk/',
    logo: 'https://dest.lk/wp-content/uploads/2022/01/cropped-Logo2-removebg-preview-300x100.png'
  },
];

function TabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ mt: 4 }}>{children}</Box> : null;
}

export default function PortfolioSection() {
  const theme = useTheme();
  const [tab, setTab] = useState(0);
  const handleTab = (_, v) => setTab(v);

  const renderCards = (items, IconComponent) =>
    <Grid container spacing={4} justifyContent="center">
      {items.map((item, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <motion.div whileHover={{ scale: 1.03 }} transition={{ type: 'spring', stiffness: 300 }}>
            <Card
              sx={{
                borderRadius: 2,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                bgcolor: 'background.paper',
                boxShadow: 2,
              }}
            >
              <Box
                sx={{
                  p: 2,
                  textAlign: 'center',
                  bgcolor:
                    tab === 0
                      ? theme.palette.primary.light
                      : tab === 1
                        ? theme.palette.secondary.light
                        : theme.palette.info.light,
                }}
              >
                {tab === 2
                  ? <Box
                      component="img"
                      src={item.logo}
                      alt={item.title}
                      sx={{ maxHeight: 48, maxWidth: 100, objectFit: 'contain', mx: 'auto' }}
                    />
                  : <IconComponent
                      size={48}
                      color={
                        tab === 0
                          ? theme.palette.primary.main
                          : theme.palette.secondary.main
                      }
                    />
                }
              </Box>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" fontWeight={700}>
                  {item.title}
                </Typography>
                {item.desc && (
                  <Typography variant="body2" color="text.secondary" sx={{ my: 1 }}>
                    {item.desc}
                  </Typography>
                )}
              </CardContent>
              <Box sx={{ p: 2, textAlign: 'center' }}>
                <Button
                  href={item.url}
                  target="_blank"
                  variant="contained"
                  color={
                    tab === 0
                      ? 'primary'
                      : tab === 1
                        ? 'secondary'
                        : 'info'
                  }
                  size="small"
                  sx={{ textTransform: 'none' }}
                >
                  {tab === 0
                    ? 'View on Play Store'
                    : tab === 1
                      ? 'View on App Store'
                      : 'Visit Website'}
                </Button>
              </Box>
            </Card>
          </motion.div>
        </Grid>
      ))}
    </Grid>;

  return (
    <Box
      component={motion.section}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      sx={{ bgcolor: 'background.default', py: { xs: 6, md: 10 } }}
    >
      <Container>
        <Typography variant="h4" align="center" fontWeight={700} color="primary.main">
          Lemda Creations
        </Typography>

        <Paper
          elevation={0}
          sx={{
            mt: 4,
            bgcolor: 'transparent',
            display: 'flex',
            justifyContent: 'center',
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Tabs
            value={tab}
            onChange={handleTab}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label={<><FaGooglePlay style={{ mr: 1 }} />Android</>} />
            <Tab label={<><FaApple style={{ mr: 1 }} />iOS</>} />
            <Tab label={<><FaGlobe style={{ mr: 1 }} />Websites</>} />
          </Tabs>
        </Paper>

        <TabPanel value={tab} index={0}>
          {renderCards(androidApps, FaGooglePlay)}
        </TabPanel>
        <TabPanel value={tab} index={1}>
          {renderCards(iosApps, FaApple)}
        </TabPanel>
        <TabPanel value={tab} index={2}>
          {renderCards(websites, FaGlobe)}
        </TabPanel>
      </Container>
    </Box>
  );
}
